module.exports = __webpack_public_path__ + "media/application/images/ui/fake-credit-card-payment-form-0c68f2f4463b488d13647815b4670b7a.png";